<template>
  <div class="seleTest xi" id="app">
    <hd-com></hd-com>
    <div class="content-wrap">
      <div class="content">
        <div class="top-div flex-start">
          <div class="left-img"></div>
          <div class="top-title">自我健康管理</div>
        </div>
        <!-- 试题 -->
        <div class="test-div flex-center">
          <div class="test-box">
            <div class="top-tip">请根据您的体验和感觉，回答以下问题：</div>
            <div class="testList-div">
              <div class="item-div" v-for="(item, index) in CurrentQuestionLst" :key="index">
                <div v-if="CurrentIndex == index">
                  <!-- 题目 -->
                  <div class="testTitle-bg">
                    <div class="quest-title">({{ index * 1 + 1 }}/{{ QuestionTotal }})【{{ item.type == "Radio" ? "单选" : (item.type == 'Judge' ? '判断'  : '多选') }}】{{ item.content.text }}</div>
                    <div class="img-box flex-start flex-wrap" v-if="item.content.imgPath.length != 0 && item.content.imgPath != null">
                      <img :src="`${Services.ossUpload}${img}`" v-for="(img, i) in item.content.imgPath" :key="i" />
                    </div>
                  </div>
                  <div class="" v-if="item.type == 'Radio'">
                    <div v-for="(option, Oindex) in item.options" :key="Oindex" @click="handle(Oindex,option.id, item)">
                      <div class="question-option">
                        <div style="display: flex; align-items: center" class="">
                          <div class="titleBoxTextimage">
                            <img :src="item.optionId == option.id || curOindex == Oindex ? urlCheck : noUrlCheck" />
                          </div>
                          <div :class="item.optionId == option.id || curOindex == Oindex ? 'active titleBoxText' : 'titleBoxText'" style="flex: 1; width: 100%">
                            {{option.content.text}}
                          </div>
                        </div>
                      </div>
                      <div class="optionsImgflexbox" v-if="option.content.imgPath.length != 0 && option.content.imgPath != null">
                        <div class="optionsImgbox" v-for="(optionimg, indexoptionimg) in option.content.imgPath" :key="indexoptionimg">
                          <img :src="`${Services.ossUpload}` + optionimg" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="" v-if="item.type == 'Judge'">
                    <div v-for="(option, Oindex) in item.options" :key="Oindex" @click="handle(Oindex,option.id, item)">
                      <div class="question-option">
                        <div style="display: flex; align-items: center" class="">
                          <div class="titleBoxTextimage">
                            <img :src="item.optionId == option.id || curOindex == Oindex ? urlCheck : noUrlCheck" />
                          </div>
                          <div :class="item.optionId == option.id || curOindex == Oindex ? 'active titleBoxText' : 'titleBoxText'" style="flex: 1; width: 100%">
                            {{option.content.text}}
                          </div>
                        </div>
                      </div>
                      <div class="optionsImgflexbox" v-if="option.content.imgPath.length != 0 && option.content.imgPath != null">
                        <div class="optionsImgbox" v-for="(optionimg, indexoptionimg) in option.content.imgPath" :key="indexoptionimg">
                          <img :src="`${Services.ossUpload}` + optionimg" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="" v-if="item.type == 'Multiple'">
                    <div v-for="(option, Oindex) in item.options" :key="Oindex" @click="handleMultiple(Oindex,option, item)">
                      <div class="question-option">
                        <div style="display: flex; align-items: center" class="">
                          <div class="titleBoxTextimage">
                            <img :src="option.checked ? urlCheckM : noUrlCheckM" />
                          </div>
                          <div :class="option.checked ? 'active titleBoxText' : 'titleBoxText'" style="flex: 1; width: 100%">
                            {{option.content.text}}
                          </div>
                        </div>
                      </div>
                      <div class="optionsImgflexbox" v-if="option.content.imgPath.length != 0 && option.content.imgPath != null">
                        <div class="optionsImgbox" v-for="(optionimg, indexoptionimg) in option.content.imgPath" :key="indexoptionimg">
                          <img :src="`${Services.ossUpload}` + optionimg" />
                        </div>
                      </div>
                    </div>
           
                  </div>
                  <!-- 选项 -->
                  <!-- <div class="test-option">
                    <el-radio-group v-model="currentQuestOption" @input="selectRes">
                      <el-radio :label="optItem.id" v-for="(optItem, opt) in item.options" :key="opt"
                        >{{ optItem.content.text }}
                        <div class="img-box flex-start flex-wrap" v-if="optItem.content.imgPath && optItem.content.imgPath.length > 0">
                          <img :src="`${Services.Statics}${img}`" v-for="(img, i) in optItem.content.imgPath" :key="i" />
                        </div>
                      </el-radio>
                    </el-radio-group>
                  </div> -->
                  <div class="testBtn-div" >
                  <el-button v-if="CurrentIndex >= 1" class="btn" @click="upQuestion(item)">
                    <span class="text">上一题</span>
                  </el-button>
                  <el-button v-if="CurrentIndex < QuestionTotal-1 && item.optionId" class="btn" @click="NextQuestion(item,index)">
                    <span class="text">下一题</span>
                  </el-button>
                  <el-button  v-if="CurrentIndex < QuestionTotal  && item.type == 'Multiple'" @click="handleMultipleSure(item)" class="btn">
                    <span class="text"> 确定(多选)</span>
                  </el-button>
                  <el-button v-if="CurrentIndex == QuestionTotal-1 && CurrentQuestionLst[CurrentIndex].optionId" class="btn" @click="getQuestRes()">
                    <span class="text">查看结果</span>
                  </el-button>
                </div>
                </div>
       
              </div>
       
            </div>
            <!-- <div class="res-div flex-start flex-wrap">
              <div class="res-item" v-for="(item, index) in optionRes" :key="index" :class="{ resOk: item.optionId }" @click="showQuest(index)">{{ index + 1 }}</div>
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <ft-com></ft-com>
    <rt-bar></rt-bar>
    <!-- <UpgradeMsgBox ref="upgradeMsgBox" @currentlyAvailable="getCurrentlyAvailable" :fullPath="$router.currentRoute.path"></UpgradeMsgBox> -->
  </div>
</template>

<script>
import hdCom from "../../components/header";
import ftCom from "../../components/footer";
// import rtBar from "../../components/right";
import { Test } from "../../components/company/test";
export default {
  name: "selfTest",
  props:['titleName'],
  components: {
    hdCom,
    ftCom,
    // rtBar,
  },
  data() {
    var test = new Test(this.TokenClient, this.Services.Statics);
    return {
      testDomain: test,
      userInfo: this.$store.state.localData.userInfo,
      title: this.$route.query.titleName?this.$route.query.titleName:'',
      currentlyAvailable: false,
      qId: 17,
      keyWord: "",
      addUser: 1,
      selectAnswerUser: "", //测试对象
      currentQuestIndex: 0, //当前试题index
      currentQuestOption: "", //当前试题选中项id
      quesInfo: {
        questions: [],
      }, //试题集
      optionRes: [], //测试对象结果list
      isComplete: false,
      resInfo: {},
      noTexttype:'t0',
      resultTrue:true,
      urlCheckM: require("@/assets/img/zdrugConsult/check.png"),
      noUrlCheckM: require("@/assets/img/zdrugConsult/znocheck.png"),
      urlCheck: require("@/assets/img/zdrugConsult/checkTrue.png"),
      noUrlCheck: require("@/assets/img/zdrugConsult/zradiono.png"),
      cssbtn:false,
      isgoId:'',
      isgoData:{},
      isgoDataList:[],
      CurrentQuestionLst:[],
      indexRa:-1,
      http:'',
      curOindex:-1,
      CurrentIndex:0,
      nextClick:true,
      userListChoose:'',
      typeMuList:{},
      typeMuListIndex:-1
    };
  },
  mounted() {
    this.http = this.Services.Statics;
    this.getQuesList();
  },
  methods: {
    // getCurrentlyAvailable(data) {
    //   console.log(data)
    //   this.currentlyAvailable = data;
    //   if (!this.currentlyAvailable) {
    //     this.$refs.upgradeMsgBox.openTip();
    //     return;
    //   }
    //   this.getQuesList();
    // },
    upQuestion(){
				var _this =this;
				if (_this.CurrentIndex > 0) {
					_this.CurrentIndex--;
					_this.curOindex = -1
				}
			},
      NextQuestion(item,index){
				var _this =this;
				if (item.optionId != undefined) {
					_this.CurrentIndex++;
				} else {
					_this.$refs.dialog.open()
					return;
				}
			},
    handleMultiple(index1,e,item1) {
				e.checked = !e.checked 
        if (e.content.text == '以上都不是') {
					if (e.checked == true) {
						for (let i = 0; i < this.CurrentQuestionLst.length; i++) {
							if (this.CurrentQuestionLst[i].id == item1.id) {
								for (let j = 0; j < this.CurrentQuestionLst[i].options.length; j++) {
									if (this.CurrentQuestionLst[i].options[j].content.text != '以上都不是') {
                      this.CurrentQuestionLst[i].options[j].checked = false
                      this.CurrentQuestionLst[i].options[j].ischecked = true
									}
								}
							}
						}
					}
					else {
						for (let i = 0; i < this.CurrentQuestionLst.length; i++) {
							if (this.CurrentQuestionLst[i].id == item1.id) {
								for (let j = 0; j < this.CurrentQuestionLst[i].options.length; j++) {
									if (this.CurrentQuestionLst[i].options[j].content.text != '以上都不是') {
                      this.CurrentQuestionLst[i].options[j].checked = false
                      this.CurrentQuestionLst[i].options[j].ischecked = false
									}
								}
							}
						}
					}
				} else {
          			for (let i = 0; i < this.CurrentQuestionLst.length; i++) {
							if (this.CurrentQuestionLst[i].id == item1.id) {
								for (let j = 0; j < this.CurrentQuestionLst[i].options.length; j++) {
									if (this.CurrentQuestionLst[i].options[j].content.text == '以上都不是') {
                      this.CurrentQuestionLst[i].options[j].checked = false
                      this.CurrentQuestionLst[i].options[j].ischecked = false
									}
								}
							}
						}
        }
			},
    handleMultipleSure(item) {
				let _this =this;
        let isChecked = item.options.some(item => item.checked == true)
          if (isChecked) {
            _this.gonextque()
          } else {
            _this.$message({
              type: 'error',
              message: '您尚未选择内容'
            });   
            return
          }
		
		},
    handle(index,value,item){
      let _this =this;
      if(_this.nextClick == true) {
        _this.nextClick = false
        for (let i=0; i<_this.CurrentQuestionLst.length; i++) {
          if (_this.CurrentQuestionLst[i].id == item.id) {
            _this.CurrentQuestionLst[i].optionId = value
            _this.curOindex = index
            _this.gonextque()
          }
        }
      } else {
        return
      }
    },
    gonextque(){
      let _this =this;
      setTimeout(()=>{
        if(_this.CurrentIndex < _this.QuestionTotal-1){
          _this.CurrentIndex++
          _this.nextClick = true
          _this.curOindex = -1
          let newQuestionTotal = 0
          newQuestionTotal = _this.QuestionTotal -1
          _this.percentnum =  100 / newQuestionTotal * _this.CurrentIndex
        } else {
          _this.nextClick = true
        }
      },500)
    
    },
    /**
     * 获取测试结果
     */
    getQuestRes() {
      var _this  = this
      let userOptions = []
      for (let i=0; i<_this.CurrentQuestionLst.length; i++) {
				if (_this.CurrentQuestionLst[i].type == 'Multiple') {
					for(let j=0; j<_this.CurrentQuestionLst[i].options.length; j++) {
						if (_this.CurrentQuestionLst[i].options[j].checked == true) {
							userOptions.push({
								optionId:_this.CurrentQuestionLst[i].options[j].id,
								questionId: _this.CurrentQuestionLst[i].id
							})
						}
					}
				} else {
					if (_this.CurrentQuestionLst[i].optionId) {
						userOptions.push({
							optionId: _this.CurrentQuestionLst[i].optionId,
							questionId: _this.CurrentQuestionLst[i].id,
							// userId :1,
							// questionnaireResultId:1,
							// questionnaireId :parseInt(_this.Id)	
						})
					} else {
						userOptions.push({
							optionId: _this.CurrentQuestionLst[i].options[0].id,
							questionId: _this.CurrentQuestionLst[i].id,
							// userId :1,
							// questionnaireResultId:1,
							// questionnaireId :parseInt(_this.Id)	
						})
					}
				}		
			}
      var userOptionInfo = {
        userOptions: userOptions,
        customerSex: this.userInfo.sex ? 1 : 0,
        customerName: this.userInfo.userName,
        customerPhone: this.userInfo.phone,
        customerAge: this.userInfo.age,
        questionnaireId: this.qId,
        isQRCode: 0, ////是否是通过扫码进来的 0表示否
        doctorId: "",
        userId: this.userInfo.id,
      };
      _this.testDomain.getUserResultId(
        userOptionInfo,
        res => {
            _this.$router.push({
            path: "/company/testResultTotal",
            query: {
              resId: res.data
            },
          });
        },
        error => {
          console.log("请求失败!请刷新重试:", error);
        }
      );
    },
    getQuesList() {
      var _this = this;
      _this.optionRes = [];
      _this.testDomain.GetQuestionList(
        _this.qId,
        0,
        0,
        res => {
          _this.quesInfo = res.data;
          if (_this.quesInfo.questions.length > 0) {
							_this.QuestionsList = res.data;
							_this.QuestionTotal =res.data.questions.length;
							for(let i=0; i<res.data.questions.length; i++) {
								res.data.questions[i].content = JSON.parse(res.data.questions[i].content)
								res.data.questions[i].content.imgPath = JSON.parse(res.data.questions[i].content.imgPath)
								for (let j=0; j<res.data.questions[i].options.length; j++) {
									res.data.questions[i].options[j].content = JSON.parse(res.data.questions[i].options[j].content)
									res.data.questions[i].options[j].content.imgPath = JSON.parse(res.data.questions[i].options[j].content.imgPath)
									if (res.data.questions[i].type == 'Multiple') {
										_this.$set(res.data.questions[i].options[j],'checked', false)
									}
								}
							}
							_this.CurrentQuestionLst = res.data.questions
          }
        },
        error => {
          _this.$message({
            type: "warning",
            message: "暂无匹配的试题!",
          });
          console.log("请求失败!请刷新重试:", error);
        }
      );
    },
  },
};
</script>

<style scoped>
::v-deep .el-progress__text {
  display: none;
}

.optionsImgbox {
  width: 245px;
  margin: 0 10px;
}
.question-option {
  margin-top: 20px;
  padding: 0 30px;
  cursor: pointer;
}
.optionsImgbox img {
  width: 100%;
  /* border-radius: 12rpx; */
  border: 1px solid #e6e6e6;
  border-radius: 12px;
}
.titleBoxTextimage {
  width: 24px;
  height: 24px;
  margin-right: 10px;
}
.titleBoxTextimage img {
  width: 100%;
  height: 100%;
}
.titleBoxText {
  font-size: 18px;
}
.titleBoxTextimage {
  width: 24px;
  height: 24px;
}
.titleBoxTextimage img {
  width: 100%;
  height: 100%;
}
.flex-s-b {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.flex-s-b-r {
  display: flex;
  flex-direction: column;
  width: 60%;
}
.delBox1 {
    width: 80px;
    /* height: 30px; */
		font-size: 16px;
		/* color: #FFFFFF; */
		/* background: #00C4AC; */
		border-radius: 15px;
		text-align: center;
    padding: 5px 0;
	}
  .delBox {
    width: 80px;
    /* height: 30px; */
		font-size: 16px;
		color: #FFFFFF;
		background: #00C4AC;
		border-radius: 15px;
		text-align: center;
    padding: 5px 0;
	}
  .userNameBox1 {
    font-size: 18px;
    color: #666666;
  }
  .selectUser-div .item-div1:hover {
  border: 1px solid #00cbb5 !important;
}
  .selectUser-div .item-div1 {
  width: 43%;
  height: 120px;
  margin-right: 2%;
  margin-bottom: 20px;
  border: 1px solid #e3e6e6;
  box-shadow: 0px 8px 15px 0px rgba(186, 186, 186, 0.14);
  border-radius: 30px;
  cursor: pointer;
  align-items: flex-start !important;
  padding: 10px 20px;
  position: relative;
}
.selectUser-div .item-div1:nth-child(3n) {
  margin-right: 0;
}
.userNameBox {
  width: 120px;
  overflow: hidden;/*超出部分隐藏*/
  white-space: nowrap;/*不换行*/
  text-overflow:ellipsis;/*超出部分文字以...显示*/
  text-align: center;
  font-size: 24px;
  font-weight: 500;
  color: #333333;
}
.content-wrap {
  background: #fff;
}
.userList-div {
  height:400px;
  overflow-y:auto
}
.zsureBtn {
  margin-right:20px;
  margin-top:20px
}
.content {
  width: 1200px;
  margin: 0 auto;
  min-height: calc(100vh - 295px - 140px);
  padding: 30px 20px;
  background: url("../../assets/img/bg001.png") top;
  background-size: 100% 1050px;
}

.top-div {
  width: 80%;
  margin: 0 auto;
  margin-bottom: 30px;
}

.top-div .left-img {
  width: 24px;
  height: 24px;
  border: 5px solid #ebeefd;
  background: linear-gradient(90deg, #4db992, #81dfa7);
  box-shadow: 0px 3px 6px 0px rgba(18, 184, 149, 0.3);
  border-radius: 50%;
  margin-right: 10px;
}

.top-div .top-title {
  width: auto;
  height: 29px;
  font-size: 30px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: #333333;
  line-height: 30px;
}

.content .addUser-div {
  background: #fff;
  width: 80%;
  margin: 0 auto;
  height: auto;
  box-shadow: 0px 8px 15px 0px rgba(186, 186, 186, 0.14);
  border-radius: 40px;
  padding: 20px 10px;
}

.content .addUser-div .addUser-box {
  background: #fff;
  width: 90%;
  margin: 0 auto;
  height: 100%;
  border-radius: 40px;
}

.addUser-div .top-tip {
  font-size: 15px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #db3a3a;
  margin-bottom: 20px;
}

.addUser-div .center-form {
  width: 100%;
}

.addUser-div .center-form /deep/ .el-form {
  width: 80%;
  margin: 0 auto;
}

.addUser-div .center-form /deep/ .el-form-item__label {
  color: #01c2ac;
  font-weight: 400;
  font-size: 17px;
}

.addUser-div .center-form .age-radio /deep/ .el-radio {
  line-height: 40px;
}

.addUser-div .center-form .age-radio {
  width: 80%;
}

.addUser-div .btn,
.selectUser-div .btn {
  width: 160px;
  height: 50px;
  background: linear-gradient(90deg, #03cdb4, #00a28e);
  box-shadow: 0px 8px 15px 0px rgba(1, 179, 157, 0.21);
  border-radius: 25px;
}
.addUser-div .btn1,
.selectUser-div .btn1 {
  width: 160px;
  height: 50px;
  background: #ffffff;
  /* box-shadow: 0px 8px 15px 0px rgba(1, 179, 157, 0.21); */
  border-radius: 25px;
}
.btn1 .text {
  font-size: 20px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #666666;
}

.btn .text {
  font-size: 20px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #ffffff;
}

.addUser-div .w-18 {
  width: 80%;
}

.selectUser-div {
  background: #fff;
  /* width: calc(80% - 60px); */
  margin: 0 auto;
  height: auto;
  box-shadow: 0px 8px 15px 0px rgba(186, 186, 186, 0.14);
  border-radius: 40px;
  padding: 30px;
}

.selectUser-div .selectUser-box,
.test-div .test-box {
  width: 90%;
}

.selectUser-div .userList-div,
.test-div .testList-div {
  width: 100%;
}

.selectUser-div .active {
  border: 1px solid #00cbb5 !important;
}

.selectUser-div .item-div:hover {
  border: 1px solid #00cbb5 !important;
}

.selectUser-div .item-div {
  width: 26%;
  height: 112px;
  margin-right: 2.5%;
  margin-bottom: 20px;
  border: 1px solid #e3e6e6;
  box-shadow: 0px 8px 15px 0px rgba(186, 186, 186, 0.14);
  border-radius: 30px;
  cursor: pointer;
  align-items: flex-start !important;
  padding: 10px 20px;
  position: relative;
}

.selectUser-div .item-div:nth-child(3n) {
  margin-right: 0;
}

.selectUser-div .userName {
  width: 100%;
  font-size: 28px;
  font-family: Source Han Sans CN;
  font-weight: 500;
}

.selectUser-div .item-div .addBtn {
  width: 100%;
  text-align: center;
  font-size: 24px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #009583;
}

.selectUser-div .userInfo {
  color: #999999;
  font-size: 16px;
}

.selectUser-div .topDel-div {
  position: absolute;
  top: 10px;
  right: 20px;
  color: #009583;
  cursor: pointer;
}
.searchInput ::v-deep() .el-input__inner {
  border-radius: 20px;
  height: 50px;
  line-height: 50px;
}
/* 测试题 */
.test-div {
  background: #fff;
  width: 80%;
  margin: 0 auto;
  height: auto;
  box-shadow: 0px 8px 15px 0px rgba(186, 186, 186, 0.14);
  border-radius: 40px;
  padding: 30px 0;
}

.test-div .top-tip {
  font-size: 15px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #333333;
  margin-bottom: 20px;
}

.test-div .test-box {
  width: 90%;
}

.test-div .test-box .testTitle-bg {
  background: #fff;
  width: 95%;
  margin: 0 auto;
  height: auto;
  padding: 15px 2.5% 20px;
  background: #f5f5f5;
  border-radius: 12px;
}

.test-div .item-div {
  background: #fff;
  width: 100%;
  height: auto;
}

.test-div .quest-title {
  font-size: 28px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #333333;
  margin-bottom: 10px;
}

.test-div .img-box {
  /* width: 96%; */
  /* margin: 0 auto; */
  margin-top: 10px;
}

.test-div .img-box img {
  border-radius: 12px;
  width: auto;
  height: 100px;
  margin-right: 5px;
  margin-bottom: 5px;
}

.test-div .test-option {
  width: 95%;
  margin: 0 auto;
  height: auto;
  padding: 20px 2.5% 10px 2.5%;
}

.test-div .test-option /deep/ .el-radio {
  width: 100%;
  margin: 10px auto 20px;
}

.test-div .test-option /deep/ .el-radio .el-radio__label {
  font-size: 25px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #666666;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.test-div .test-option /deep/ .el-radio .el-radio__inner {
  width: 25px;
  height: 25px;
  border: 1px solid #666666;
  margin-top: -10px;
}

.test-div .test-option /deep/ .el-radio .el-radio__inner::after {
  width: 9px;
  height: 9px;
  left: 53%;
}

.test-div .testBtn-div {
  width: 95%;
  margin: 0 auto;
  height: auto;
  padding: 30px 2.5%;
}

.test-div .testBtn-div .btn {
  width: 120px;
  height: 40px;
  background: linear-gradient(90deg, #03cdb4, #00a28e);
  box-shadow: 0px 8px 15px 0px rgba(1, 179, 157, 0.15);
  border-radius: 20px;
}

.test-div .testBtn-div .btn span {
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #ffffff;
}

.test-div .res-div {
  width: 95%;
  margin: 0 auto;
  height: auto;
  padding: 30px 2.5%;
}

.test-div .res-div .res-item {
  width: 42px;
  height: 42px;
  line-height: 42px;
  background: #ffffff;
  border: 1px solid #d9d9d9;
  border-radius: 10px;
  margin: 0 5px 5px 0;
  text-align: center;
  cursor: pointer;
}

.test-div .res-div .resOk {
  background: #d7fef9;
  border: 1px solid #00c1a9;
}
</style>
